import Model, { ID, MODEL_LEVEL } from 'src/models/model'
import Librariable from 'src/models/model/concerns/Librariable'

export default class CustomBlock extends Model {
  static name = 'CustomBlock'

  static level = MODEL_LEVEL.SITE

  static duplicatable = true
  static paginate = true

  static employeeRequiredPermissionCategories = [Model.permissionCategories.SiteContent]

  static define () {
    this.concerns = [Librariable]

    this.fields = {
      id: {
        type: ID,
        required: true
      },
      name: {
        type: String,
        default: null
      },
      category: {
        type: String,
        default: null
      },
      content: {
        type: String,
        default: '',
        excludeFromDefault: true,
        translatable: true
      },
      styles: {
        type: String,
        default: '',
        excludeFromDefault: true
      }
    }
  }
}
